import { useEffect } from "react";
import api from "../lib/api";

export default function SEO({ page = "home", titleFallback = "Orax Solar", descFallback = "" }) {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/seo/${page}`);
        if (cancelled) return;
        document.title = data.title || titleFallback;
        setMeta("description", data.description || descFallback);
        setMeta("keywords", data.keywords || "");
        // OG tags
        setMeta("og:title", data.title || titleFallback, true);
        setMeta("og:description", data.description || descFallback, true);
        setMeta("og:type", "website", true);
      } catch {
        document.title = titleFallback;
      }
    })();
    return () => { cancelled = true; };
  }, [page, titleFallback, descFallback]);

  return null;
}

function setMeta(name, content, isProperty = false) {
  const attr = isProperty ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
